import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNivelGeneticoGeneral`, method: 'GET', body: null, token: token})
}